import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { removeExtraSpaces } from '../../scripts/helpers';
var IconsHolder = /*#__PURE__*/function (_React$PureComponent) {
  function IconsHolder() {
    _classCallCheck(this, IconsHolder);
    return _callSuper(this, IconsHolder, arguments);
  }
  _inherits(IconsHolder, _React$PureComponent);
  return _createClass(IconsHolder, [{
    key: "render",
    value: function render() {
      var classBasename = 'icons-holder';
      var step = this.props.step || '';
      var size = step ? '' : this.props.size ? "".concat(classBasename, "-").concat(this.props.size) : "".concat(classBasename, "-md");
      var variant = this.props.variant ? "".concat(classBasename, "-").concat(this.props.variant) : ' ';
      var cl = this.props["class"] || this.props.className || '';
      var shape = step ? "".concat(classBasename, "-round") : this.props.shape ? "".concat(classBasename, "-").concat(this.props.shape) : ' ';
      var icon = this.props.icon || '';
      var fullClass = removeExtraSpaces("".concat(classBasename, " ").concat(cl, " ").concat(step ? 'content-holder' : '', " ").concat(icon, " ").concat(size, " ").concat(shape, " ").concat(variant));
      return React.createElement("span", {
        className: "".concat(fullClass)
      }, step);
    }
  }]);
}(React.PureComponent);
export default IconsHolder;